<template>
    <div>
        <!-- Preloader -->
        <PagePreloader v-if="!pageIsLoaded"></PagePreloader>

        <!-- Error management -->
        <CustomAlerts :errors="errors"></CustomAlerts>
    </div>
</template>

<style lang="scss" scoped>
@import "~bootstrap-vue/dist/bootstrap-vue.css";
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from "axios";
import ApiService from "@/core/services/api.service";
import PagePreloader from "@/view/content/Custom/PagePreloader.vue";
import CustomAlerts from "@/view/content/Custom/CustomAlerts.vue";
//    import ClipboardJS from "clipboard";
//    window.ClipboardJS = ClipboardJS;

export default {
    name: "FacebookCallback",
    components: {
        PagePreloader,
        CustomAlerts,
    },
    data() {
        return {
            // Preloaders
            pageIsLoaded: false,

            // Displayers

            // Error management
            errors: [],

            // Forms
        };
    },

    methods: {
        // First method here
        processCallback() {
            // Get all parameters
            var params = {};
            location.search
                .substr(1)
                .split("&")
                .forEach(function (item) {
                    params[item.split("=")[0]] = item.split("=")[1];
                });

            // Check we're not missing anything
            if (typeof params.code === "undefined" || typeof params.state === "undefined") {
                this.$router.push({
                    name: "accountinsights",
                    params: {
                        propFlashMessages: "unknown_error",
                    },
                });
            } else {
                // Perform post
                console.log("Preparing to submit POST to callback");
                console.log("Code is :");
                console.log(params.code);
                axios
                    .get("accountinsights/callback?code=" + params.code + "&state=" + params.state)
                    .then((response) => {
                        // Make pretty
                        var data = response.data;

                        console.log(data); //FIXME

                        // Redirect to page once we're good
                        this.$router.push({
                            name: "accountinsights",
                            params: {
                                propFlashMessages: data.messages,
                            },
                        });
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                    .finally(() => {
                        this.pageIsLoaded = true;
                    });
            }
        },
    },
    mounted() {
        // ApiService.setHeader();
        this.processCallback();
        // Set breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [{ title: "Facebook Callback", route: "dashboard" }]);
    },
};
</script>
